import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanDelivery extends BaseModelAPI {
	static entity = 'surat jalan delivery';
	static entityName = 'suratjalandelivery';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.suratJalanNumber = '';
			this.id = '';
			this.deliveryInstructionId = '';
			this.deliveryInstruction = {};
			this.deliveryDate = '';
			this.isAlreadyDeliver = false;
			this.customerId = '';
			this.customer = {};
			this.destinationId = '';
			this.destination = {};
			this.remarks = '';
			this.driverName = '';
			this.vehicleNumber = '';
			this.suratJalanDeliveryDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}